import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { ChatService } from '../../services/chat/chat.service';

import { UserModel } from '@sc/types';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { DefaultChatGroups } from '@sc/types';
import { stripHTML } from '../../util/stripHTML';

@Component({
  selector: 'sc-chat-group-menu',
  templateUrl: './chat-group-menu.component.html',
  styleUrls: ['./chat-group-menu.component.scss'],
})
export class ChatGroupMenuComponent {
  @Input() user: UserModel;
  @Input() sessionID: string;
  chatGroupName: string;

  constructor(
    private toastrService: ToastrService,
    private popoverController: PopoverController,
    private chatService: ChatService,
    private analyticsService: AnalyticsService
  ) {}

  async createChatGroup() {
    this.chatGroupName = stripHTML(this.chatGroupName);
    this.chatGroupName = this.chatGroupName.trim();
    try {
      const nameValid = !Object.values(DefaultChatGroups).includes(
        this.chatGroupName.toLowerCase() as DefaultChatGroups
      );

      if (nameValid) {
        await this.chatService.createChatGroup(this.sessionID, this.chatGroupName);

        this.toastrService.success(null, `Successfully created new Chat Group`, {
          progressBar: true,
          progressAnimation: 'decreasing',
          closeButton: true,
          tapToDismiss: false,
          timeOut: 5 * 1000,
          toastComponent: GeneralToastComponent,
        });

        await this.analyticsService.track('created chat group', { success: true });
      } else {
        this.toastrService.error(null, `Can't create Chat Group with this name!`, {
          progressBar: true,
          progressAnimation: 'decreasing',
          closeButton: true,
          tapToDismiss: false,
          timeOut: 5 * 1000,
          toastComponent: GeneralToastComponent,
        });
      }
    } catch (error) {
      this.toastrService.error(null, `Failed to create new Chat Group`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      await this.analyticsService.track('created chat group', { success: false });
    } finally {
      await this.popoverController.dismiss();
    }
  }
}
